import { render } from "./AudioMenuConfig.vue?vue&type=template&id=43793d78&scoped=true&ts=true"
import script from "./AudioMenuConfig.vue?vue&type=script&lang=ts"
export * from "./AudioMenuConfig.vue?vue&type=script&lang=ts"

import "./AudioMenuConfig.vue?vue&type=style&index=0&id=43793d78&lang=scss&scoped=true"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43793d78"]])

export default __exports__